import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "version-option" }
const _hoisted_2 = {
  key: 0,
  class: "version-option-date"
}
const _hoisted_3 = { class: "version-option" }
const _hoisted_4 = {
  key: 0,
  class: "version-option-date"
}

import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import LabeledSelect from '@shell/components/form/LabeledSelect';

export interface VersionOption {
  label: string;
  value: string;
  date?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppCoVersionSelect',
  props: {
    value: {},
    options: {},
    loading: { type: Boolean },
    mode: {}
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {



// eslint-disable-next-line func-call-spacing
const emit = __emit;

const store = useStore();
const { t } = useI18n(store);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LabeledSelect), {
    value: __props.value,
    options: __props.options,
    loading: __props.loading,
    mode: __props.mode,
    label: _unref(t)('fleet.helmOp.appCoConfig.chartVersion'),
    searchable: true,
    "option-key": "value",
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (emit('update:value', $event)))
  }, {
    option: _withCtx((opt) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(opt.label), 1),
        _cache[1] || (_cache[1] = _createTextVNode()),
        (opt.date)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(opt.date), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    "selected-option": _withCtx((opt) => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(opt.label), 1),
        _cache[2] || (_cache[2] = _createTextVNode()),
        (opt.date)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(opt.date), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["value", "options", "loading", "mode", "label"]))
}
}

})